import React from 'react';
import './LoadingSpinner.css';

/**
 * Unified loading indicator used across the entire app.
 *
 * size:    'small' | 'medium' (default) | 'large'
 * variant: 'default'  — centered in its container with padding (page sections, tables)
 *          'fullpage' — fills remaining viewport height (full-page loading states)
 *          'overlay'  — position:absolute over parent (parent needs position:relative)
 *          'button'   — tiny inline, no padding, no message (inside button labels)
 */
const LoadingSpinner = ({ message, size = 'medium', variant = 'default' }) => (
  <div
    className={`ls ls--${size} ls--${variant}`}
    role="status"
    aria-label={message || 'Loading'}
  >
    <div className="ls__ring">
      <div className="ls__arc" />
    </div>
    {variant !== 'button' && message && (
      <p className="ls__msg">{message}</p>
    )}
  </div>
);

export default LoadingSpinner;
